import * as React from 'react'
import {Descriptions, PageHeader, Row, Col, InputNumber, Button, Tooltip, Table} from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'
import moment from 'moment'

import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { StressTestInputModel, StressTestModel, StressTestRow } from '../../models/StressTestModels'
import { formatEuro } from '../shared/CurrencyFormat'
import { IStresstestService } from '../../services/StresstestService'
import {PianoPrevisionaleDetailsModel, PianoPrevisionaleIntestazione} from '../../models/PianoPrevisionaleModels'
import { IPianoPrevisionaleService } from '../../services/PianoPrevisionaleService'
import { PianoPrevisionaleParams } from './PianoPrevisionaleParams'
import { TTFormItem } from '../shared/TTFormItem'
import { TTInputCurrency } from '../shared/TTInputCurrency'
import { CalculatorOutlined, InfoCircleTwoTone, SaveOutlined } from '@ant-design/icons'
import { EmbedConfig, EmbedToken } from '../../models/EmbedConfig'
import { IUtilityService } from '../../services/UtilityService'
import { Embed, models, Report } from 'powerbi-client'
import { PowerBIEmbed } from 'powerbi-client-react'
import {ModelBase} from "../../models/ModelBase";
import {Movimento, SorgenteType} from "../../models/RaccoltaDatiModels";
import Column from "antd/lib/table/Column";


class PianoPrevisionaleDetailsState extends PianoPrevisionaleIntestazione {
    FatturoPrevistoPerc: number
    IncassatoPrevistoPerc: number
    FatturoOriginale: number
    IncassatoOriginale: number
    reportconfig: EmbedConfig
    details: PianoPrevisionaleDetailsModel
}



class PianoPrevisionaleDetailsComp extends React.Component<RouteComponentProps<PianoPrevisionaleParams>, PianoPrevisionaleDetailsState> {

    service: IPianoPrevisionaleService
    utilityService: IUtilityService
    report: Report

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.PIANO_PREVISIONALE)
        this.utilityService = container.get(SERVICE_IDENTIFIER.UTILITY_SERVICE)

        var model = new EmbedConfig()
        model.EmbedToken = new EmbedToken()

        let _state = new PianoPrevisionaleDetailsState()
        _state.reportconfig = model;
        this.state = _state;
    }

    componentDidMount() {
        this.loadPage()
        this.loadReport()
    }

    loadPage = async () => {
        let resp = await this.service.GetPianoPrevisonaleDettagli(this.props.match.params.id)
        if (resp.IsValid == true) {
            this.setState({ ...resp, FatturoOriginale: resp.FatturoPrevisto, IncassatoOriginale: resp.IncassatoPrevisto })
        }
    }

    private async loadReport() {
        // var model = await this.utilityService.GetReportByName('ReportPP', this.state.Cliente)
        // //var model = await this.utilityService.GetReport('0b1611b6-6a1a-4134-aa93-82d5df77b10f', 'b7c2a451-8117-45ca-9be9-692ac36b8d19');
        // //var model = await this.utilityService.GetDashboard('87138ce4-ba20-41f7-8ca8-544c94a32608', 'b7c2a451-8117-45ca-9be9-692ac36b8d19',' 94f688f7-4557-4d77-a28b-5bf29fe09392');
        // this.setState({ ...this.state, reportconfig: model })
        // if (this.report != null) this.report.refresh()

        let model = await this.service.GetPianoPrevisonale(this.props.match.params.id);
        if (model.IsValid) this.setState({...this.state , details : model})
    }

    setReport(report: Report) {
        this.report = report
    }


    onSave = async () => {
        let resp = await this.service.CalcolaPianoProvvigionale(this.props.match.params.id, this.state)
        if (resp.IsValid) {
            this.loadPage()
            this.loadReport()
        }
    }

    fattEuroToPerc = (val: number) => {
        let res = this.euroToPerc(this.state.FatturoOriginale, val)
        let model = { ...this.state }
        model.FatturoPrevistoPerc = res
        model.FatturoPrevisto = val
        this.setState(model)
    }

    fattPercToEuro = (val: number) => {
        let res = this.percToEuro(this.state.FatturoOriginale, val)
        let model = { ...this.state }
        model.FatturoPrevisto = res
        model.FatturoPrevistoPerc = val
        this.setState(model)
    }

    incEuroToPerc = (val: number) => {
        let res = this.euroToPerc(this.state.IncassatoOriginale, val)
        let model = { ...this.state }
        model.IncassatoPrevistoPerc = res
        model.IncassatoPrevisto = val
        this.setState(model)
    }

    incPercToEuro = (val: number) => {
        let res = this.percToEuro(this.state.IncassatoOriginale, val)
        let model = { ...this.state }
        model.IncassatoPrevisto = res
        model.IncassatoPrevistoPerc = val
        this.setState(model)
    }

    euroToPerc = (original: number, val: number): number => {
        let diff = val - original
        let perc = (diff * 100) / original
        return Number(perc.toFixed(2))
    }

    percToEuro = (original: number, val: number) => {
        let euro = (val * original) / 100
        let tot = (original + euro)
        return Number(tot.toFixed(2))
    }

    tooltipMgs: string = "I valori possono essere modificati sia in € (primo valore) che in % (secondo valore)"

    render() {
        return (
            <PageHeader title={`Piano previsionale ${this.state.Anno}`} onBack={() => this.props.history.goBack()} extra={[
                <Button type="primary" key="save" icon={<CalculatorOutlined />} onClick={() => this.onSave()}>Ricalcola</Button>
            ]}>
                <Row gutter={[0, 0]}>
                    <Col xs={24} lg={12} xl={12}>
                        <TTFormItem tooltip={this.tooltipMgs} label="Fatturato" required={true}>
                            <TTInputCurrency style={{ width: '100%' }} value={this.state.FatturoPrevisto} onChange={e => this.fattEuroToPerc(e as number)} />
                            <InputNumber style={{ width: '100%' }} value={(this.state.FatturoPrevistoPerc == null ? 0 : this.state.FatturoPrevistoPerc)} onChange={e => this.fattPercToEuro(e as number)} />
                        </TTFormItem>
                    </Col>
                    <Col xs={24} lg={12} xl={12}>
                        <TTFormItem label="Costi fissi %" required={true}>
                            <InputNumber style={{ width: '100%' }} value={this.state.CostiFissiPercentuale} onChange={e => this.setState({ CostiFissiPercentuale: e as number })} />
                        </TTFormItem>
                    </Col>
                    <Col xs={24} lg={12} xl={12}>
                        <TTFormItem tooltip={this.tooltipMgs} label="Incassato" required={true}>
                            <TTInputCurrency style={{ width: '100%' }} value={this.state.IncassatoPrevisto} onChange={e => this.incEuroToPerc(e as number)} />
                            <InputNumber style={{ width: '100%' }} value={(this.state.IncassatoPrevistoPerc == null ? 0 : this.state.IncassatoPrevistoPerc)} onChange={e => this.incPercToEuro(e as number)} />
                        </TTFormItem>
                    </Col>
                    
                    <Col xs={24} lg={12} xl={12}>
                        <TTFormItem label="Costi variabili %" required={true}>
                            <InputNumber style={{ width: '100%' }} value={this.state.CostiVariabiliPercentuale} onChange={e => this.setState({ CostiVariabiliPercentuale: e as number })} />
                        </TTFormItem>
                    </Col>
                </Row>
                <br />
                <hr />
                {this.state.details &&
                    <Table
                        dataSource={this.state.details.Elements}
                        pagination ={false}>
                        <Column title="Mese" dataIndex="Descrizione"  />
                        <Column title="Gennaio"  dataIndex="Gennaio"  render={(value: number) => formatEuro(value)} />
                        <Column title="Febbraio"  dataIndex="Febbraio"  render={(value: number) => formatEuro(value)} />
                        <Column title="Marzo"  dataIndex="Marzo"  render={(value: number) => formatEuro(value)} />
                        <Column title="Aprile"  dataIndex="Aprile"  render={(value: number) => formatEuro(value)} />
                        <Column title="Maggio"  dataIndex="Maggio"  render={(value: number) => formatEuro(value)} />
                        <Column title="Giugno"  dataIndex="Giugno"  render={(value: number) => formatEuro(value)} />
                        <Column title="Luglio"  dataIndex="Luglio"  render={(value: number) => formatEuro(value)} />
                        <Column title="Agosto"  dataIndex="Agosto"  render={(value: number) => formatEuro(value)} />
                        <Column title="Settembre"  dataIndex="Settembre"  render={(value: number) => formatEuro(value)} />
                        <Column title="Ottobre"  dataIndex="Ottobre"  render={(value: number) => formatEuro(value)} />
                        <Column title="Novembre"  dataIndex="Novembre"  render={(value: number) => formatEuro(value)} />
                        <Column title="Dicembre"  dataIndex="Dicembre"  render={(value: number) => formatEuro(value)} />
                    </Table>
                }
                

            </PageHeader>
        )
    }
}

export const PianoPrevisionaleDetails = withRouter(PianoPrevisionaleDetailsComp)
